<template>
  <router-view />
</template>

<style>
/* Reset default browser margins */
body, html {
  margin: 0;
  padding: 0;
  width: 100%;
  overflow-x: hidden;
}

#app {
  /* Remove the default Vue centering and margins */
  text-align: left;
  margin: 0;
  padding: 0;
}
</style>